/* eslint-disable */

import React from 'react';
import * as PropTypes from "prop-types";
import {SearchkitComponent, SortingAccessor, SortingProps} from "searchkit";

const defaults = require("lodash/defaults");

class CustomSortingSelector extends SearchkitComponent {
  // accessor:SortingAccessor;

  static propTypes = defaults({
    options:PropTypes.arrayOf(
      PropTypes.shape({
        label:PropTypes.string.isRequired,
        field:PropTypes.string,
        order:PropTypes.string,
        defaultOption:PropTypes.bool
      })
    )
  }, SearchkitComponent.propTypes);

  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  defineAccessor() {
    return new SortingAccessor("sort", {options:this.props.options})
  }

  handleClick(e) {
    this.accessor.state = this.accessor.state.setValue(e.currentTarget.id);
    this.searchkit.performSearch();
  }

  render() {
      if (!this.accessor) return null;
      const allOptions = this.accessor.options.options;
      const selected = this.accessor.getSelectedOption().field;
      const items = allOptions.map((options) =>
        <a onClick={this.handleClick} id={options.key} key={options.key} className="dropdown-item text-decoration-none text-dark">
            {selected === options.field ? (<i className="far fa-check text-green"></i>) : null}&nbsp;{options.label}
        </a>
      );
      return (
          <React.Fragment>
          <div className="dropdown">
              <a className="btn btn-default dropdown-toggle dfi-btn" id="dropdownSortingItems" role="button"
                 data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  <i className="far fa-sort"></i>
              </a>
              <div className="dropdown-menu" aria-labelledby="dropdownSortingItems">
                  {items}
              </div>
          </div>
          </React.Fragment>
    );
  }
}

export default CustomSortingSelector;


